import { useAuth } from '../../../src/context/AuthContext';
import WalletScreen from '../../../src/screens/WalletScreen';
import AdminCustomTasksScreen from '../../../src/screens/AdminCustomTasksScreen';

export default function WalletTab() {
  const { user } = useAuth();
  if (user?.role === 'ADMIN') return <AdminCustomTasksScreen />;
  return <WalletScreen />;
}
